<!--<ul>-->
<!--<li *ngFor="let menuItem of menuItems">-->
<!--{{menuItem}}-->
<!--</li>-->
<!--</ul>-->


<div class="sidebar-nav" style="width: 100%;">

  <div class="navbar navbar-default" role="navigation">

    <div class="navbar-header">
      <button type="button" class="navbar-toggle" data-bs-toggle="collapse" data-bs-target=".sidebar-navbar-collapse">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <span class="visible-xs navbar-brand"></span>
    </div>
    <div class="navbar-collapse collapse sidebar-navbar-collapse">
      <ul class="nav navbar-nav">
        <li>@for (menuItem of menuItems; track menuItem) {
          <a href="#">{{menuItem}}</a>
        }</li>
      </ul>
    </div><!--/.nav-collapse -->
  </div>

</div>
